import { gql, useApolloClient } from '@apollo/client';

import { ReviewDataFragment } from '@notino/shared/definitions/types';

type ReviewFromCache = ReviewDataFragment | null;

const REVIEW_FRAGMENT = gql`
  fragment ReviewData on Review {
    id
    like
    dislike
    alreadyLiked
    alreadyDisliked
    score
    text
    title
    userName
    authorType
    createdDate
    isAnonymized
    originalShopId
    sourceLanguage
    variantId
    translatedFrom
    partnerDomain
    originalText
    originalTitle
    agency {
      name
      url
    }
    attributes {
      pros
      cons
    }
    images {
      thumbnailUrl
      fullSizeUrl
    }
  }
`;

export const useReviewFromCache = (reviewId: number): ReviewFromCache => {
  const client = useApolloClient();

  try {
    return client.cache.readFragment({
      id: `Review:${reviewId}`,
      fragment: REVIEW_FRAGMENT,
    });
  } catch {
    // If fragment is not in cache, return null
    return null;
  }
};
